import React from "react"
import { Auth } from "../../../Components/Views/Auth/Auth"
import { AuthFormView } from "../../../Models/Client/AuthFormView"

export function ForgotPasswordRoute() {
    return <Auth type={AuthFormView.forgot} squashSuccessMessage={false} />
}
